export default "__VITE_ASSET__Db2Xg$U1__"